import { UserCheck, Users } from "lucide-react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SettingCard } from "@/components/settings/setting-card";
import { SettingField } from "@/components/settings/setting-field";
import { FormControl, FormField, FormItem } from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import type { SaveField } from "../../../hooks/use-auto-save-field";
import type { BookingBehaviorFormData } from "../types";

interface ManualBookingSettingsProps {
  saveField: SaveField<BookingBehaviorFormData>;
  savingFields: Set<keyof BookingBehaviorFormData>;
}

export function ManualBookingSettings({ saveField, savingFields }: ManualBookingSettingsProps) {
  const { t } = useTranslation("settings");
  const form = useFormContext<BookingBehaviorFormData>();

  return (
    <SettingCard title={t("manualBookingSettings.title")} icon={<UserCheck className="h-5 w-5" />}>
      <div className="space-y-6">
        {/* Capacity Management */}
        <div className="space-y-4">
          <h4 className="font-medium text-foreground flex items-center">
            <Users className="w-4 h-4 mr-2" />
            {t("manualBookingSettings.capacityManagement.title")}
          </h4>

          <FormField
            control={form.control}
            name="manualCountPendingTowardCapacity"
            render={({ field }) => (
              <FormItem id="field-booking-manual-count-pending">
                <SettingField
                  label={t("manualBookingSettings.capacityManagement.countPending.label")}
                  helpText={t("manualBookingSettings.capacityManagement.countPending.description")}
                >
                  <FormControl>
                    <Switch
                      checked={field.value}
                      onCheckedChange={(value) => {
                        void saveField("manualCountPendingTowardCapacity", value);
                      }}
                      disabled={savingFields.has("manualCountPendingTowardCapacity")}
                    />
                  </FormControl>
                </SettingField>
              </FormItem>
            )}
          />
        </div>
      </div>
    </SettingCard>
  );
}
